export const EMPTY_OPTION_VALUE = "empty";
export const EMPTY_OPTION_DEFAULT_LABEL = "Без секции";
